import { useLocation, useNavigate } from "react-router-dom";
import { Home, CalendarDays, FolderKanban, Inbox, Terminal, Settings, AudioLines } from "lucide-react";
import { useInboxStats } from "@/hooks/useInboxStats";
import { useCommandStyle } from "@/contexts/CommandStyleContext";

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: inboxStats } = useInboxStats();
  const { copy } = useCommandStyle();

  const navItems = [
    { path: "/", label: copy.dashboard, icon: Home },
    { path: "/week", label: copy.calendar, icon: CalendarDays },
    { path: "/projects", label: copy.projects, icon: FolderKanban },
    { path: "/transcripts", label: copy.transcripts, icon: AudioLines },
    { path: "/sessions", label: copy.sessions, icon: Terminal },
    { path: "/messages", label: copy.inbox, icon: Inbox },
    { path: "/settings", label: copy.settings, icon: Settings },
  ];

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-border"
      style={{ backgroundColor: "#0D0D0D", paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-center justify-around h-14">
        {navItems.map(({ path, label, icon: Icon }) => {
          const active = isActive(path);
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              aria-label={label}
              aria-current={active ? "page" : undefined}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 min-w-0 h-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset ${
                active
                  ? "text-primary"
                  : "hover:text-foreground"
              }`}
              style={active ? undefined : { color: "#555555" }}
            >
              <div className="relative">
                <Icon className="h-4 w-4" />
                {path === "/messages" && inboxStats && inboxStats.total > 0 && (
                  <span className="absolute -top-1 -right-2 min-w-[14px] h-3.5 rounded-full bg-accent text-[9px] font-bold text-white flex items-center justify-center px-0.5">
                    {inboxStats.total > 9 ? "9+" : inboxStats.total}
                  </span>
                )}
              </div>
              <span className="text-[9px] font-medium truncate max-w-full">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
